import React, { useCallback, useState } from 'react';
import * as PropTypes                   from 'prop-types';
import { useTranslation }               from 'react-i18next';

import HeaderSearchIcon from '../../icons/HeaderSearchIcon';
import SearchCrossIcon  from '../../icons/SearchCrossIcon';

const SearchLine = function(props) {
  const {
          reset,
          resetTimeout,
          search,
          searchClose,
          searchInput,
          setSearchInput,
          setShowSearch,
        } = props;

  const [pending, setPending] = useState(false);
  const { t }                 = useTranslation();

  let timer = null;

  const onChange = useCallback(
    (event) => {
      resetTimeout();

      if (!isSSR()) {
        clearTimeout(timer);
      }

      const {
              target: { value },
            } = event;

      setSearchInput(value);
      setShowSearch(false);

      if (value !== '' && !isSSR()) {
        timer = setTimeout(() => {
          setPending(true);
          setTimeout(() => setPending(false), 2500);
        }, 500);
        search(decodeURI(value));
      }
    },
    [search, resetTimeout, setSearchInput],
  );

  const handleReset = useCallback(() => {
      if (!pending) {
        setSearchInput('');
        reset();
        searchClose();
      }
    },
    [pending, reset, setSearchInput, searchClose],
  );

  return (
    <div className={'searchLine'}>
      <input
        autoFocus={true}
        type={'text'}
        placeholder={t('label_what_you_looking')}
        onChange={onChange}
        value={searchInput}
        onClick={(event) => event.stopPropagation()}
      />
      {!!searchInput.trim() ? (
        <div
          className={'icon_wrapper'}
          onClick={handleReset}
        >
          <SearchCrossIcon />
        </div>
      ) : <HeaderSearchIcon />
      }
    </div>
  );
};

SearchLine.propTypes = {
  reset:          PropTypes.func.isRequired,
  resetTimeout:   PropTypes.func.isRequired,
  search:         PropTypes.func.isRequired,
  searchClose:    PropTypes.func.isRequired,
  searchInput:    PropTypes.string.isRequired,
  setSearchInput: PropTypes.func.isRequired,
};

export default SearchLine;
